import * as React from 'react';

import _ from 'underscore';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import type ReviewSchemaPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/yesNo/models/schema';

import { Radio, RadioGroup, Typography2 } from '@coursera/cds-core';

import InlineValidationErrorV2 from 'bundles/assess-common/components/InlineValidationErrorV2';
import type { YesNoStructuredPart, YesNoStructuredPartDefinition } from 'bundles/assess-common/types/Reviews';
import type { ValidationError } from 'bundles/assess-common/types/ValidationErrors';
import Content from 'bundles/phoenix/components/Content';

import _t from 'i18n!nls/ondemand';

import 'css!./__styles__/YesNoFormPart';

type Props = {
  disabled: boolean;
  reviewSchemaPart: typeof ReviewSchemaPart;
  reviewPart?: YesNoStructuredPart;
  onChange?: (change: YesNoStructuredPartDefinition) => void;
  validationError?: ValidationError | null;
};

class YesNoFormPart extends React.Component<Props> {
  handleChange = (optionId: $TSFixMe) => {
    if (!this.props.disabled && this.props.onChange) {
      this.props.onChange({ choice: optionId });
    }
  };

  render() {
    const { disabled, reviewSchemaPart, reviewPart, validationError } = this.props;
    const validationLabelId = reviewSchemaPart.id ? `form-part-label-${reviewSchemaPart.id}` : undefined;
    const promptId = `${reviewSchemaPart.id}-prompt`;

    const options = [
      {
        label: 'Yes',
      },
      {
        label: 'No',
      },
    ];

    return (
      <div className="rc-YesNoFormPart">
        <div className="options-prompt">
          <Content contentId={promptId} assumeStringIsHtml={false} content={reviewSchemaPart.get('prompt')} />
        </div>
        <InlineValidationErrorV2 id={validationLabelId} validationError={validationError} />
        <RadioGroup aria-describedby={promptId} aria-labelledby={`${promptId} ${validationLabelId}`}>
          {options.map((option) => (
            <Radio
              key={option.label}
              className="peer-option-input"
              disabled={disabled}
              name={`peer-yes-no-${reviewSchemaPart.id}`}
              value={option.label}
              checked={reviewPart && option.label === reviewPart.definition.choice}
              aria-checked={reviewPart && option.label === reviewPart.definition.choice}
              onChange={() => this.handleChange(option.label)}
              label={
                (
                  <div className="option-contents">
                    {reviewSchemaPart.get('points') && (
                      <Typography2 component="div" variant="subtitleMedium" color="inherit">
                        <FormattedMessage
                          message={_t('{points, plural, one{# point} other{# points}}')}
                          points={reviewSchemaPart.getChoicePoints(option.label)}
                        />
                      </Typography2>
                    )}
                    <Typography2
                      component="div"
                      variant="bodyPrimary"
                      color="inherit"
                      data-testid="yes-no-content-container"
                    >
                      {option.label}
                    </Typography2>
                  </div>
                ) as unknown as string
              }
            />
          ))}
        </RadioGroup>
      </div>
    );
  }
}

export default YesNoFormPart;
